import { FormattedMessage } from 'react-intl'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import TriplePointTakeoverLogo from './TriplePointTakeoverLogo'

function TriplePointTakeoverBannerContent() {
  const [tier] = useCurrentLoyaltyTier()

  return <Group direction="horizontal" gap={12} verticalAlign="center">
    <TriplePointTakeoverLogo size="small" />
    <BodyText variant="medium" weight="bold" colour={`tier-${tier}-contrast`}>
      <FormattedMessage
        id="8_Xpcc1qUdrQdtsAHu7Q"
        defaultMessage="Enjoy triple bonus Société Points on this limited-time special offers."
        description="Offer-page specific text for triple points takeover banner in the offer's page"
      />
    </BodyText>
  </Group>
}

export default TriplePointTakeoverBannerContent
